import React from 'react';
import { NavLink } from 'react-router-dom';
import { SolutionBlock, SolutionsStyled, SolutionsWrapper, SolutionTitle } from './Solutions.styled';
import Section from '../../components/Section/Section';
import Container from '../../components/Container/Container';
import { PageTitle, SectionTitle } from '../../components/PageTitle/PageTitle.styled';
import solutionsBg from '../../assets/images/solution/background.png';
import solution01 from '../../assets/images/solution/adas.jpg';
import solution02 from '../../assets/images/solution/dms.jpg';
import CustomersBlock from '../../components/CustomersBlock/CustomersBlock';
// @ts-ignore
import SEO from '@americanexpress/react-seo';

function Solutions(): JSX.Element {
  return (
    <SolutionsStyled>
      <SEO
        title="RGRauto | Solutions"
      />
      <Section style={{ paddingTop: '0' }} backgroundImage={solutionsBg}>
        <Container>
          <PageTitle>Solutions</PageTitle>
          <SolutionsWrapper>
            <SolutionBlock>
              <NavLink exact to="/mobileye">
                <img src={solution01} alt="mobileye" />
                <SolutionTitle>
                  Advanced Drive Assistance
                  <br />
                  Systems (ADAS)
                </SolutionTitle>
              </NavLink>
            </SolutionBlock>
            <SolutionBlock>
              <NavLink exact to="/driver-monitoring-system">
                <img src={solution02} alt="driver-monitoring-system" />
                <SolutionTitle>
                  Driver monitoring
                  <br />
                  Systems (DMS)
                </SolutionTitle>
              </NavLink>
            </SolutionBlock>
            <SolutionBlock>
              <NavLink exact to="/fleet-telematics">
                <SolutionTitle>
                  Fleet Telematics and Safety
                  <br />
                  Management Systems
                </SolutionTitle>
              </NavLink>
            </SolutionBlock>
          </SolutionsWrapper>
        </Container>
      </Section>

      <Section>
        <Container>
          <SectionTitle>We proudly serve private small-to-medium fleets as well as large corporate fleets</SectionTitle>
          <CustomersBlock />
        </Container>
      </Section>
    </SolutionsStyled>
  );
}

export default Solutions;
